<div style="display: flex; margin: 80px; justify-content: center;" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<ng-container *ngIf="!loading">
    <div *ngIf="dataSource.data.length == 0">
        <h3>Nenhuma oportunidade foi encontrada.</h3>
    </div>
    <div *ngIf="dataSource.data.length > 0">
        <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Nome completo</th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>
            <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contato</th>
                <td mat-cell *matCellDef="let element">{{element.contact | mask: "(99) 99999-9999"}}</td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef>Data de criação</th>
                <td mat-cell *matCellDef="let element">{{element.createdAtString}}</td>
            </ng-container>
            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let element">
                    <button 
                        mat-mini-fab 
                        matTooltip="Editar" 
                        matTooltipPosition="above"
                        (click)="edit.emit(element.id)"
                        class="btn-style"
                    >
                        <fa-icon icon="pencil-alt"></fa-icon>
                    </button>
                    <button 
                        mat-mini-fab 
                        matTooltip="Inativar caso" 
                        matTooltipPosition="above"
                        class="btn-style"
                        style="background-color: red !important;"
                        (click)="inactivateCase.emit(element.id)"
                    >
                        <fa-icon icon="trash-alt"></fa-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        </table>
    </div>
</ng-container>
<mat-paginator 
     [length]="total"
     [pageSize]="pageLength"
     [hidePageSize]="true"
     (page)="pageChange.emit($event)"
 >